<div class="history-container">
  <!-- <div class="action-bar">
    <span class="title">Histórico</span>
    <div class="dropdown-box">
      <app-dropdown-button [isOpen]="historyFilterOpen"
      (valueChange)="historyFilterOpen = $event"
      [label]="historyFilter.value"
      [alignRight]=true>
        <ul class="dropdown-text-list">
          <div id="fac-history-filter-{{i}}" *ngFor="let item of combosList; let i = index">
            <li (click)="setFilter(item)">
              {{item.value}}                  
            </li>
          </div>           
        </ul>
      </app-dropdown-button>
    </div>
  </div> -->
  <div class="wrap" *ngIf="historyList.length > 0">
    <div class="filter" *ngFor="let history of historyListFilter; let h = index">
      <div class="log-container" id="history-history{{h}}">
        <div class="log-header">
          <img id="history-profile-pic{{h}}" *ngIf="history.profile_image_url"  [src]="history.profile_image_url" onerror="this.src='../../../../../../assets/svgs/user.svg';" alt="Profile" height="20" width="20">
          <img class="default-img" id="history-no-profile-pic{{h}}" *ngIf="!history.profile_image_url"  src="../../../../../../assets/svgs/user.svg" alt="User" height="20" width="20">
          <span id="history-user{{h}}">{{history.nickname}} em: {{history.record_time | date:'dd/MM/yyyy'}} às {{history.record_time | date:'HH:mm'}}</span>
        </div>
        <div class="record" *ngIf="history.type === 'activities'">
          <div class="log-fields">
            <div class="fac-stage" *ngIf="history.record?.funnel_stage">
              <span class="semi-bold">Estágio</span>
              <span id="history-content-type" class="data">{{history.record.funnel_stage}}</span>
            </div>
            <div class="contact-container" *ngIf="history.record?.contact_type || history.record?.return_date || history.record?.visit_date">
              <div class="contact-type" *ngIf="history.record?.contact_type">
                <span class="semi-bold">Tipo de contato:</span>
                <span id="history-content-type" class="data">{{history.record.contact_type}}</span>
              </div>
              <div class="return-date" *ngIf="history.record?.return_date">
                <span class="semi-bold">Retornar em:</span>
                <span id="history-return-date" class="data">{{history.record.return_date | date: 'dd/MM/yyyy HH:mm'}}</span>
              </div>
              <div class="return-date" *ngIf="history.record?.visit_date">
                <span class="semi-bold">Visita em:</span>
                <span id="history-return-date" class="data">{{history.record.visit_date | date:'dd/MM/yyyy HH:mm'}}</span>
              </div>
            </div>
            <div class="products" *ngIf="history.record?.products && history.record?.products.length > 0">
              <span class="semi-bold">Produtos Ofertados</span>
              <span id="history-product{{i}}" *ngFor="let empreendimento of history.record.products; let i = index;" class="data" [innerHTML]="empreendimento.name"></span>
            </div>
            <div class="notes" *ngIf="history.record?.description">
              <span class="semi-bold">Observação</span>
              <span id="history-description" class="data" [innerHTML]="history.record.description"></span>
            </div>
          </div>
          <div class="attachment" *ngIf="history.record?.attachments && history.record.attachments.length > 0">
            <span class="semi-bold">Anexos</span>
            <div class="grid">
              <div class="attached" (click)="downloadFile(att)" *ngFor="let att of history.record.attachments; let j = index">
                <img [ngClass]="{'svg-icon': isNotImage(att) }" id="history-att{{j}}" [src]="setFilePreview(att)" alt="" height="60" width="60" [title]="att.name">
                <span *ngIf="isNotImage(att)">{{ att.name.split('.').pop() }}</span>
              </div>
            </div>

            <div class="attachment-upload" *ngIf="history.record?.upload_status">
              <div [ngSwitch]="history.record?.upload_status.status">
                <div class="attachment-processing" *ngSwitchCase="'PROCESSING'">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.99998 14.6668C4.31798 14.6668 1.33331 11.6822 1.33331 8.00016C1.33331 4.31816 4.31798 1.3335 7.99998 1.3335C11.682 1.3335 14.6666 4.31816 14.6666 8.00016C14.6666 11.6822 11.682 14.6668 7.99998 14.6668ZM7.99998 13.3335C9.41447 13.3335 10.771 12.7716 11.7712 11.7714C12.7714 10.7712 13.3333 9.41465 13.3333 8.00016C13.3333 6.58567 12.7714 5.22912 11.7712 4.22893C10.771 3.22873 9.41447 2.66683 7.99998 2.66683C6.58549 2.66683 5.22894 3.22873 4.22874 4.22893C3.22855 5.22912 2.66665 6.58567 2.66665 8.00016C2.66665 9.41465 3.22855 10.7712 4.22874 11.7714C5.22894 12.7716 6.58549 13.3335 7.99998 13.3335ZM8.66665 8.00016H11.3333V9.3335H7.33331V4.66683H8.66665V8.00016Z" fill="#6E6E6E"/>
                  </svg>                
                  <span class="attachment-upload-msg">{{history.record.upload_status.upload_status_message}}</span>
                </div>
              </div>           
            </div>

          </div>
        </div>
        <div class="discard-fac"*ngIf="history.type === 'discard'">
          <div class="log-fields">
            <span> Descartou a fac</span>
            <div class="reason">
              <span>Razão do descarte</span>
              <span class="data">{{history.record.reason}}</span>
            </div>
            <div class="notes">
              <span>Observação</span>
              <span class="data">{{history.record.description}}</span>
            </div>
          </div>
        </div>
        <div class="non-record" *ngIf="history.type !== 'activities'">
          <div class="log-fields">
            <div *ngFor="let activity of history.activities" id="history-action" class="action">
              <div [innerHTML]="activity"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="history-filter-empty" *ngIf="historyListFilter.length === 0 && historyList.length > 0">
      <span>Não existe histórico de "{{historyFilter.value.toLowerCase()}}"</span>
    </div>
  </div>
  
  <div id="history-not-found" class="not-found" *ngIf="facHistory?.status?.id === 2">
    <div class="log-container">
      <span>{{facHistory.messages ? facHistory.messages[0].message : 'Não foi possível carregar o histórico, tente atualizar a página.'}}</span>
    </div>
  </div>

  <div class="loading" *ngIf="!facHistory">
    <lib-loading></lib-loading>
  </div>

</div>